"use client";

import React from "react";
import {useState, useRef} from "react";
import {
    Box,
    Flex,
    Heading,
    Text,
    Button,
    Image,
    IconButton,
    Link,
    SimpleGrid,
    Grid,
    GridItem,
    Menu,
    Portal,
} from "@chakra-ui/react";
import {motion, useScroll, useTransform} from "framer-motion";
import {FiChevronUp, FiMenu} from "react-icons/fi";
import {FiChevronRight} from "react-icons/fi"
import {FaLinkedin} from "react-icons/fa";
import * as PropTypes from "prop-types";

const MotionBox = motion(Box);

const contactUrl = process.env.REACT_APP_CONTACT_FORM_URL;
const demoUrl = process.env.REACT_APP_DEMO_URL;

// TODO: add more US-centric information
// TODO: Who you're speaking to (lenders, CDFIs, insurance, retailers, etc)
// TODO: CFPB, PnP script para frases. First card made for agriculture.

const sections = [
    {
        title: "Automate Manual Analysis",
        subtitle: "Automate data collection and analysis to eliminate manual work, lower operational costs, and improve overall efficiency.",
        img: "/website-media/sections/dynamic_maps.jpg",
    },
    {
        title: "Agronomic Data, Reimagined",
        subtitle: "Transform field information and productivity into capital and operation decisions.",
        img: "/website-media/sections/ag_field.jpg",
    },
    {
        title: "Full Transparency in Real Time",
        subtitle: "Real-time insights from diverse sources enhancing decision-making in complex situations and minimizing delays.",
        img: "/website-media/sections/ag_satellite.jpg",
    },
    {
        title: "AI-Driven Analysis",
        subtitle: "Our AI algorithms offer in-depth analysis and insights on the latest trends and developments in the industry.",
        img: "/website-media/sections/market_analysis.jpg",
    },
];

const features = [
    {
        title: "Elevate Customer Experience",
        subtitle: "Provide a seamless, transparent, and fast application process that builds trust with your clients.",
        img: "/website-media/features/digital_form.png",
    },
    {
        title: "Accelerate Decision-Making",
        subtitle: "Turn a 60-day process into less than 5 minutes and deploy loans through co-branded credit cards.",
        img: "/website-media/features/tap_to_pay.png",
    },
    // {
    //     title: "Faster and More Accurate Decisions",
    //     subtitle: "Leverage AI-powered insights to build stronger relationships with farmers, originate bigger loans, and lend with confidence.",
    //     img: "/ag-data.jpg",
    // },
    {
        title: "Become the Go-To Lender for Farmers",
        subtitle: "Unlock new revenue opportunities by expanding your lending capacity and reducing missed opportunities.",
        img: "/website-media/features/leading_lender.png",
    },
    // {
    //     title: "Reduce Underwriting Costs",
    //     subtitle: "Automate data collection and analysis to minimize manual work, lower operational costs, and improve overall efficiency.",
    //     img: "/ux-ui.jpeg",
    // },
];

const partners = [
    "/fintech_sandbox.png",
    "/plug_and_play_logo.png",
    // "./logos/partner3.png",
    // "./logos/partner4.png",
];

const news = [
    {
        title: "Fintech Sandbox Demo Day",
        date: "April 2026",
        description: "We will be showcasing Agxes at Fintech Sandbox Demo Day during NYC Fintech Week, presenting to leading investors, operators, and innovators in the financial technology ecosystem.",
        image: "/fintech_sandbox.png",
    },
    {
        title: "MIT Women's Venture Challenge",
        date: "March 2026",
        description: "We are incredibly proud to share that Victoria Tostado Bringas won first place at the 4th Annual MIT Women's Venture Challenge in New York City, pitching Agxes to a room of investors and founders and taking home a $10,000 check.",
        image: "/website-media/news-icons/mit_womens_vc.png",
    },
    {
        title: "Boston Fintech Week Panel",
        date: "September 2025",
        description: "Agxes Joins the Brightest Minds in Fintech in the 2025 Fintech Sandbox Innovation Forum. We will be panelists in the New Faces of Boston Fintech and Breaking Barriers: Underrepresented Founders Redefining Fintech.",
        image: "/website-media/news-icons/fintech_week.png",
    },
    {
        title: "Agxes Presents at Plug and Play Seed4Growth",
        date: "August 2025",
        description: "Agxes was selected by Plug and Play in the 2025 Seed4Growth program. We were invited to the August Innovation Showcase in Denver, CO, where we presented our solution to an audience of Agriculture Lenders and other leaders in the Agtech and Fintech space. ",
        image: "/website-media/news-icons/seed_4_growth.png",
    },
    {
        title: "Agxes Joins the Fintech Sandbox Residency Program",
        date: "March 2025",
        description: "We’re thrilled to announce that Agxes has been selected to join the prestigious Fintech Sandbox Data Access Residency! As part of the program, Agxes will have access to top-tier financial data to further refine our AI models and continue empowering underserved agricultural communities.",
        image: "/fintech_sandbox.png",
    },
    // {
    //     title: "Agxes Named Semifinalist in NFX Lite FAST 2024 Competition!",
    //     date: "November 2024",
    //     description: "We’re excited to announce that Agxes was selected as one of the Top 30 Semifinalists from over 300+ teams in the highly competitive Lite MIT FAST 2024 competition! We’re proud to have made it to the semifinals and are grateful for the opportunity to share our vision.",
    // },
];

function DecorativeBox(props) {
    return null;
}

DecorativeBox.propTypes = {children: PropTypes.node};
export default function LandingPage() {
    const {scrollY} = useScroll();
    const parallaxY = useTransform(scrollY, [0, 500], [0, -100]);
    const parallaxY2 = useTransform(scrollY, [3700, 4100], [0, -100]);
    const [showAll, setShowAll] = useState(false);
    // Attach the ref to a standard Chakra Box that we know handles refs correctly
    const sectionRef = useRef(null);

    const toggleNews = () => {
        if (showAll) {
            setShowAll(false);
            // Smooth scroll back to the title of the news section
            if (sectionRef.current) {
                sectionRef.current.scrollIntoView({behavior: "smooth"});
            }
        } else {
            setShowAll(true);
        }
    };

    const visibleNews = showAll ? news : news.slice(0, 3);
    const hasMoreThanThree = news.length > 3;

    return (
        // <Box bg="agxes.primary">
        <Box w="full" minH="100vh">
            {/*<Box*/}
            {/*    position="absolute"*/}
            {/*    inset={0}*/}
            {/*    overflow="hidden"*/}
            {/*    zIndex={-1}*/}
            {/*>*/}
            {/*    <Box*/}
            {/*        position="absolute"*/}
            {/*        top="20%"*/}
            {/*        left="15%"*/}
            {/*        w="400px"*/}
            {/*        h="400px"*/}
            {/*        bg="radial-gradient(circle, rgba(83,171,145,0.5) 0%, transparent 70%)"*/}
            {/*        filter="blur(50px)"*/}
            {/*        animation="move1"*/}
            {/*    />*/}
            {/*    <Box*/}
            {/*        position="absolute"*/}
            {/*        top="60%"*/}
            {/*        left="60%"*/}
            {/*        w="500px"*/}
            {/*        h="500px"*/}
            {/*        bg="radial-gradient(circle, rgba(108,219,131,0.4) 0%, transparent 70%)"*/}
            {/*        filter="blur(120px)"*/}
            {/*        animation="move2"*/}
            {/*    />*/}
            {/*    <Box*/}
            {/*        position="absolute"*/}
            {/*        top="40%"*/}
            {/*        left="40%"*/}
            {/*        w="300px"*/}
            {/*        h="300px"*/}
            {/*        bg="radial-gradient(circle, rgba(23,52,65,0.4) 0%, transparent 70%)"*/}
            {/*        filter="blur(80px)"*/}
            {/*        animation="move3"*/}
            {/*    />*/}
            {/*</Box>*/}
            {/*<Box*/}
            {/*    position="absolute"*/}
            {/*    inset={0}*/}
            {/*    bg="agxes.primary" // Your dark brand color (#173441)*/}
            {/*    zIndex={-2}*/}
            {/*/>*/}

            {/*<Box*/}
            {/*    position="absolute"*/}
            {/*    inset={0}*/}
            {/*    overflow="hidden"*/}
            {/*    z-index={-1}*/}
            {/*>*/}
            {/*    <Box*/}
            {/*        position="absolute"*/}
            {/*        top="20%"*/}
            {/*        left="15%"*/}
            {/*        w="400px"*/}
            {/*        h="400px"*/}
            {/*        bg="radial-gradient(circle, rgba(83,171,145,0.8) 0%, transparent 70%)"*/}
            {/*        filter="blur(80px)"*/}
            {/*        animation="move1 18s ease-in-out infinite"*/}
            {/*    />*/}
            {/*    <Box*/}
            {/*        position="absolute"*/}
            {/*        top="60%"*/}
            {/*        left="60%"*/}
            {/*        w="500px"*/}
            {/*        h="500px"*/}
            {/*        bg="radial-gradient(circle, rgba(108,219,131,0.7) 0%, transparent 70%)"*/}
            {/*        filter="blur(120px)"*/}
            {/*        animation="move2 22s ease-in-out infinite"*/}
            {/*    />*/}
            {/*    <Box*/}
            {/*        position="absolute"*/}
            {/*        top="40%"*/}
            {/*        left="40%"*/}
            {/*        w="300px"*/}
            {/*        h="300px"*/}
            {/*        bg="radial-gradient(circle, rgba(23,52,65,0.6) 0%, transparent 70%)"*/}
            {/*        filter="blur(80px)"*/}
            {/*        animation="move3 26s ease-in-out infinite"*/}
            {/*    />*/}
            {/*</Box>*/}

            {/*<Box position="absolute" inset={0} bg="#173441" z-index={-2} rounded={"3xl"} m={6} mt={24}>*/}
            {/*<Box position="absolute" inset={0} bg="#173441" z-index={-2} overflow="hidden" rounded={"4xl"} m={6}*/}
            {/*     mt={32}>*/}
            {/*    <Box position="absolute" inset={0} overflow="hidden" z-index={-1} rounded={"3xl"}>*/}
            {/*        <Box*/}
            {/*            position="absolute"*/}
            {/*            top="-10%"*/}
            {/*            left="-5%"*/}
            {/*            w="1000px"*/}
            {/*            h="900px"*/}
            {/*            bg="radial-gradient(circle, rgba(83,171,145,0.8) 0%, transparent 70%)"*/}
            {/*            filter="blur(40px)"*/}
            {/*            animation={`move2 12s ease-in-out infinite`}*/}
            {/*        />*/}
            {/*        <Box*/}
            {/*            position="absolute"*/}
            {/*            top="-10%"*/}
            {/*            left="25%"*/}
            {/*            w="1300px"*/}
            {/*            h="900px"*/}
            {/*            bg="radial-gradient(circle, rgba(108,218,131,0.6) 0%, transparent 70%)"*/}
            {/*            filter="blur(40px)"*/}
            {/*            animation={`move3 12s ease-in-out infinite`}*/}
            {/*        />*/}
            {/*    </Box>*/}
            {/*</Box>*/}
            <Box position="absolute" inset={0} bg="agxes.primary" z-index={-2} overflow="hidden" rounded="4xl" m={6}
                 mt={32}>
                <Box position="absolute" inset={0} overflow="hidden" z-index={-1} rounded="4xl">
                    {/* Moving radial gradients */}
                    <Box
                        position="absolute"
                        top="-10%"
                        left="-5%"
                        w="1000px"
                        h="900px"
                        bg="radial-gradient(circle, rgba(83,171,145,0.8) 0%, transparent 70%)"
                        filter="blur(40px)"
                        animation={`move2 12s ease-in-out infinite`}
                    />
                    <Box
                        position="absolute"
                        top="-10%"
                        left="25%"
                        w="1300px"
                        h="900px"
                        bg="radial-gradient(circle, rgba(108,218,131,0.6) 0%, transparent 70%)"
                        filter="blur(40px)"
                        animation={`move3 12s ease-in-out infinite`}
                    />

                    {/* Noise overlay */}
                    <Box
                        position="absolute"
                        inset={0}
                        opacity={0.1}
                        pointerEvents="none"
                        style={{
                            backgroundImage:
                            // "url('/grainy-noise.png')",
                            // "url('/grain-Effect.png')",
                            //     "url('/broken-noise.png')",
                                "url('/grainy-noise-3.png')",
                            backgroundSize: "cover",
                            mixBlendMode: "overlay"
                        }}
                    />
                </Box>
            </Box>


            {/* HEADER */}
            <Flex
                as="header"
                align="center"
                justify="space-between"
                p={3}
                bg="white"
                boxShadow="xs"
                position="fixed"
                top={0}
                left={0}
                right={0}
                rounded="2xl"
                zIndex={999} // Use a high number for zIndex
                m={6}
                mx={9}
            >
                <Flex align="center" gap={2} ml={2}>
                    <Image src="/favicon.ico" height={9} alt="Agxes Logo"/>
                    <Heading fontFamily="DMSans" fontSize="4xl" color={"#033642"}>Agxes</Heading>
                </Flex>
                <Flex gap={6} display={{base: "none", md: "flex"}} alignItems="center">
                    <Link href="#news">News</Link>
                    <Button
                        as="a"
                        href={demoUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        size="md"
                        bg="agxes.accent"
                        rounded="lg"
                        color="agxes.primary"
                        boxShadow="inset 0 0 8px rgba(255, 255, 255, 0.5)"
                        _hover={{
                            bg: "agxes.accentLight",
                            boxShadow: "inset 0 0 10px rgba(255, 255, 255, 0.35)",
                        }}
                        transition="all 0.3s ease"
                    >
                        See it in action
                    </Button>

                </Flex>
                <Box display={{base: "block", md: "none"}}>
                    <Menu.Root>
                        <Menu.Trigger asChild>
                            <IconButton
                                aria-label="Options"
                                icon={<FiMenu/>}
                                variant="outline"
                            ><FiMenu/></IconButton>
                        </Menu.Trigger>
                        <Portal>
                            <Menu.Positioner>
                                <Menu.Content>
                                    <Menu.Item asChild value="news">
                                        <Link href="#news">News</Link>
                                    </Menu.Item>
                                    {/*<Menu.Item asChild value="partners">*/}
                                    {/*    <Link href="#partners">Partners</Link>*/}
                                    {/*</Menu.Item>*/}
                                    {/*<Menu.Item asChild value="contact">*/}
                                    {/*    <Link href="#contact">Contact</Link>*/}
                                    {/*</Menu.Item>*/}
                                    <Menu.Item asChild value="demo">
                                        <Button
                                            as="a"
                                            href={demoUrl}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            size="sm"
                                            bg="agxes.accent"
                                            rounded="lg"
                                            color="agxes.primary"
                                            boxShadow="inset 0 0 8px rgba(255, 255, 255, 0.5)"
                                            _hover={{
                                                bg: "agxes.accentLight",
                                                boxShadow: "inset 0 0 10px rgba(255, 255, 255, 0.35)",
                                            }}
                                            transition="all 0.3s ease"
                                        >
                                            See it in action
                                        </Button>
                                    </Menu.Item>
                                </Menu.Content>
                            </Menu.Positioner>
                        </Portal>
                    </Menu.Root>
                </Box>
            </Flex>

            {/* HERO SECTION WITH PARALLAX BACKGROUND - REMOVE zIndex AND ADD pt */}
            {/*<MotionBox*/}
            {/*    style={{y: parallaxY}}*/}
            {/*    position="relative"*/}
            {/*    minH="100vh"*/}
            {/*    display="flex"*/}
            {/*    alignItems="center"*/}
            {/*    justifyContent="center"*/}
            {/*    textAlign="center"*/}
            {/*    color="white"*/}
            {/*    pt="100px" // offset for fixed header*/}
            {/*>*/}
            {/*    <MotionBox*/}
            {/*        initial={{opacity: 0, y: 30}}*/}
            {/*        animate={{opacity: 1, y: 0}}*/}
            {/*        transition={{duration: 1}}*/}
            {/*        p={16}*/}
            {/*        // maxW="6xl"*/}
            {/*        w="full"*/}
            {/*    >*/}
            {/*        <Grid*/}
            {/*            templateColumns={{base: "1fr", md: "1fr 1fr"}}*/}
            {/*            gap={16}*/}
            {/*            alignItems="center" // vertically center both columns*/}
            {/*        >*/}
            {/*            /!* Text Column *!/*/}
            {/*            <GridItem display="flex" flexDirection="column" alignItems="center" justifyContent="center"*/}
            {/*                      textAlign="center"*/}
            {/*                // borderWidth="0.5px" borderColor={"red"}*/}
            {/*            >*/}
            {/*                <Heading*/}
            {/*                    fontFamily="DMSans"*/}
            {/*                    fontSize={{base: "2xl", md: "4xl", lg: "5xl"}}*/}
            {/*                    lineHeight="1"*/}
            {/*                    mb={4}*/}
            {/*                >*/}
            {/*                    Smart AI Infrastructure for Agricultural Lenders*/}
            {/*                </Heading>*/}
            {/*                <Text fontFamily="DMSans" fontSize={{base: "lg", md: "2xl"}} mb={4} lineHeight="1.6">*/}
            {/*                    Supercharge your loan throughput by 200x*/}
            {/*                </Text>*/}
            {/*                /!*<Box borderWidth="0.5px" borderColor="gray.300" p="2px" rounded="2xl" bg="gray.300/30"*!/*/}
            {/*                /!*     w="min">*!/*/}
            {/*                <Button*/}
            {/*                    size="lg"*/}
            {/*                    bg="agxes.accent"*/}
            {/*                    rounded="xl"*/}
            {/*                    color="agxes.primary"*/}
            {/*                    boxShadow="inset 0 0 8px rgba(255, 255, 255, 0.5)" // always-on inner glow*/}
            {/*                    _hover={{*/}
            {/*                        bg: "agxes.accentLight",*/}
            {/*                        boxShadow: "inset 0 0 10px rgba(255, 255, 255, 0.35)", // slightly stronger glow on hover*/}
            {/*                    }}*/}
            {/*                    transition="all 0.3s ease"*/}
            {/*                >*/}
            {/*                    Request a Demo*/}
            {/*                </Button>*/}


            {/*                /!*</Box>*!/*/}

            {/*            </GridItem>*/}

            {/*            /!* Image Column *!/*/}
            {/*            <GridItem display="flex" flexDirection="column" alignItems="center" justifyContent="center"*/}
            {/*                      textAlign="center">*/}
            {/*                <Box borderWidth="0.5px"*/}
            {/*                     borderColor="gray.300" p={"5px"} rounded="2xl" bg="gray.200/30">*/}
            {/*                    <Image*/}
            {/*                        src="/Agxes Financial Insights.png"*/}
            {/*                        rounded="xl"*/}
            {/*                        maxH={{base: "200px", md: "400px"}}*/}
            {/*                        objectFit="contain"*/}

            {/*                    />*/}
            {/*                </Box>*/}

            {/*            </GridItem>*/}
            {/*            <GridItem display="flex" flexDirection="column" alignItems="center" justifyContent="center"*/}
            {/*                      textAlign="center">*/}
            {/*                <Box borderWidth="0.5px"*/}
            {/*                     borderColor="gray.300" p={"5px"} rounded="4xl" bg="gray.200/30">*/}
            {/*                    <Box*/}
            {/*                        width="190px" // This is the visible area (the "crop")*/}
            {/*                        height="408px"*/}
            {/*                        overflow="hidden"*/}
            {/*                        position="relative" // Acts as the positioning context for the image*/}
            {/*                        rounded="3xl"*/}
            {/*                    >*/}
            {/*                        <Image*/}
            {/*                            src="/phone_screen.png"*/}
            {/*                            position="absolute" // Position the image relative to the Box*/}
            {/*                            top="-1px" // Adjust these values to choose which part of the image to show*/}
            {/*                            left="-1px"*/}
            {/*                            maxH="410px" // Override the parent's height constraints if needed*/}
            {/*                            maxW="210px" // Override the parent's width constraints if needed*/}
            {/*                        />*/}
            {/*                    </Box>*/}
            {/*                </Box>*/}

            {/*            </GridItem>*/}
            {/*        </Grid>*/}
            {/*    </MotionBox>*/}
            {/*</MotionBox>*/}


            <MotionBox
                style={{y: parallaxY}}
                position="relative"
                minH="100vh"
                display="flex"
                alignItems="center"
                justifyContent="center"
                textAlign="center"
                color="white"
                pt="100px" // offset for fixed header
            >
                <MotionBox
                    initial={{opacity: 0, y: 30}}
                    animate={{opacity: 1, y: 0}}
                    transition={{duration: 1}}
                    p={{base: 6, md: 12, lg: 16}}
                    w="full"
                    maxW="7xl"
                    mx="auto"
                >
                    <Grid
                        templateColumns={{base: "1fr", md: "1fr 1fr"}}
                        gap={{base: 8, md: 16}}
                        alignItems="center"
                    >
                        {/* TEXT COLUMN */}
                        <GridItem
                            display="flex"
                            flexDirection="column"
                            alignItems={{base: "center", md: "flex-start"}}
                            textAlign={{base: "center", md: "left"}}
                            justifyContent="center"
                        >
                            <Heading
                                fontFamily="DMSans"
                                fontSize={{base: "2xl", md: "4xl", lg: "6xl"}}
                                lineHeight="1.2"
                                mb={4}
                                px={{base: "20px", md: "0px"}}
                            >
                                Supercharge Your Loan Throughput by 200x
                            </Heading>
                            <Text
                                fontFamily="DMSans"
                                fontSize={{base: "lg", md: "2xl"}}
                                mb={6}
                                lineHeight="1.6"
                                color={"white"}
                                maxW="500px"
                            >
                                Smart AI Infrastructure for Agricultural Lenders
                            </Text>
                            <Button
                                as="a"
                                href={demoUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                size="lg"
                                bg="agxes.accent"
                                rounded="xl"
                                color="agxes.primary"
                                boxShadow="inset 0 0 8px rgba(255, 255, 255, 0.5)"
                                _hover={{
                                    bg: "agxes.accentLight",
                                    boxShadow: "inset 0 0 10px rgba(255, 255, 255, 0.35)",
                                }}
                                transition="all 0.3s ease"
                            >
                                See it in action
                            </Button>
                        </GridItem>

                        {/* IMAGES COLUMN */}
                        {/* IMAGES COLUMN */}
                        <GridItem display="flex" flexDirection="column" alignItems="center">
                            <Box
                                position="relative"
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                w="full"
                                maxW="600px"
                            >
                                {/* FINANCIAL INSIGHTS */}
                                <Box
                                    borderWidth="0.5px"
                                    borderColor="gray.300"
                                    p="5px"
                                    rounded="2xl"
                                    bg="gray.200/30"
                                    shadow="lg"
                                    w={{base: "80%", md: "100%"}}
                                >
                                    <Image
                                        a src="/Agxes Financial Insights.png"
                                        rounded="xl"
                                        // w="80%"
                                        h="auto"
                                        objectFit="contain"
                                    />
                                </Box>

                                {/* PHONE SCREEN (overlaps only on md+) */}
                                <Box
                                    borderWidth="0.5px"
                                    borderColor="gray.300"
                                    p="5px"
                                    rounded="4xl"
                                    bg="gray.200/30"
                                    shadow="xl"
                                    position={{base: "absolute", md: "absolute"}}
                                    top={{base: "48", md: "48"}}   // adjust overlap height
                                    left="50%"
                                    transform={{base: "translateX(-50%)", md: "translateX(-50%)"}}
                                    zIndex="10"
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                >
                                    <Box
                                        width="190px"
                                        height="408px"
                                        width={{base: "142px", md: "190px"}}
                                        height={{base: "306px", md: "408px"}}
                                        overflow="hidden"
                                        rounded="3xl"
                                    >
                                        <Image
                                            src="/phone_screen.png"
                                            w="100%"
                                            h="100%"
                                            objectFit="contain"
                                        />
                                    </Box>
                                </Box>
                            </Box>
                        </GridItem>


                    </Grid>
                </MotionBox>
            </MotionBox>

            <MotionBox
                // bg={"gray.100"}
                // rounded="3xl"
                initial={{opacity: 0, y: 40}}
                whileInView={{opacity: 1, y: 0}}
                viewport={{once: true, amount: 0.1}}
                transition={{duration: 0.8, ease: "easeOut"}}
            >
                <Text
                    textAlign={{base: "center", md: "center"}}
                    pt={24}
                    mx={{base: 4, md: 12, lg: 32}}
                    px={{base: 4, md: 12, lg: 24}}
                    pb={{base: 8, md: 16}}
                    fontSize={{base: "3xl", md: "4xl", lg: "5xl"}}
                    fontWeight="bold"
                    color="agxes.primary"
                >
                    The First Expense Management Credit Card Made for Agriculture
                </Text>
            </MotionBox>

            <MotionBox
                // bg={"agxes.primary"}
                // bg={"gray.100"}
                // rounded="3xl"
                initial={{opacity: 0, y: 40}}
                whileInView={{opacity: 1, y: 0}}
                viewport={{once: true, amount: 0.1}}
                transition={{duration: 0.8, ease: "easeOut"}}
            >
                <Box
                    h="61vh"
                    display="flex"
                    overflowX="auto"
                    scrollSnapType="x mandatory"
                    scrollBehavior="smooth" // smooth scrolling
                    mb={24}
                    px={{base: 4, md: 12, lg: 24}} // padding for first & last feature
                    sx={{
                        "& > div": {scrollSnapAlign: "center"},
                        // Hide scrollbar (WebKit: Chrome, Safari, Opera)
                        "::-webkit-scrollbar": {display: "none"},
                        // Hide scrollbar (Firefox)
                        scrollbarWidth: "none",
                        // Hide scrollbar (IE/Edge)
                        msOverflowStyle: "none",
                        // Optional: enable smooth touch scroll on Safari iOS
                        WebkitOverflowScrolling: "touch",
                    }}
                >
                    {features.map((feature, idx) => (
                        <MotionBox
                            key={idx}
                            bg="agxes.primary"
                            p={8}
                            m={4} // spacing between cards
                            w={{base: "400px", md: "400px", lg: "400px"}}
                            flexShrink={0}
                            rounded="4xl"
                            borderWidth="0.5px"
                            borderColor="gray.200"
                            shadow="xs"
                            position="relative"
                            whileHover={{scale: 1.01}}
                            transition={{duration: 0.2, ease: "easeOut"}}
                        >
                            {/* Noise overlay only on background */}
                            <Box
                                position="absolute"
                                inset={0}
                                opacity={0.15}
                                pointerEvents="none"
                                rounded="4xl"
                                z-index={0}
                                style={{
                                    backgroundImage: "url('/grainy-noise-3.png')",
                                    backgroundSize: "cover",
                                    mixBlendMode: "overlay",
                                }}
                            />

                            {/* Content above noise */}
                            <Box position="relative" z-index={1}>
                                <Text
                                    color="white"
                                    fontFamily="DMSans"
                                    fontWeight="medium"
                                    fontSize={{base: "4xl", md: "4xl"}}
                                    mb={4}
                                    lineHeight="1.2"
                                >
                                    {feature.title}
                                </Text>
                                <Text color="white" mb={4}>
                                    {feature.subtitle}
                                </Text>
                                <Box
                                    w="full"
                                    h={0}
                                    pb="65%"                // 🔥 makes the box a perfect square (1:1 ratio)
                                    position="relative"
                                    overflow="hidden"
                                    rounded="2xl"
                                    display="flex"
                                    alignItems="center"
                                    justifyContent="center"
                                    // bg="blackAlpha.200"      // optional: subtle background
                                >
                                    <Image
                                        src={feature.img}
                                        alt={feature.title}
                                        objectFit="cover"       // or "contain" if you prefer seeing the whole image
                                        position="absolute"
                                        top={0}
                                        left={0}
                                        w="100%"
                                        h="100%"
                                        rounded="2xl"
                                    />
                                </Box>

                            </Box>
                        </MotionBox>
                    ))}
                </Box>
            </MotionBox>


            {/* CONTENT SECTIONS */}
            {/*{sections.map((section, idx) => (*/}
            {/*    <MotionFlex*/}
            {/*        key={idx}*/}
            {/*        display="flex"*/}
            {/*        direction={{base: "column", md: idx % 2 === 0 ? "row" : "row-reverse"}}*/}
            {/*        align="center"*/}
            {/*        justify="space-between"*/}
            {/*        px={{base: 4, md: 20}}*/}
            {/*        py={12}*/}
            {/*        gap={10}*/}
            {/*        initial={{opacity: 0, y: 40}}*/}
            {/*        whileInView={{opacity: 1, y: 0}}*/}
            {/*        viewport={{once: true, amount: 0.1}}*/}
            {/*        transition={{duration: 0.8, ease: "easeOut"}}*/}
            {/*    >*/}
            {/*        <MotionBox flex="1" initial={{opacity: 0, y: 40}} whileInView={{opacity: 1, y: 0}}*/}
            {/*                   transition={{duration: 0.8}}>*/}
            {/*            <Heading color="agxes.primary" fontFamily="DMSans" fontSize={{base: "3xl", md: "5xl"}} mb={4}*/}
            {/*                     lineHeight="1.2">*/}
            {/*                {section.title}*/}
            {/*            </Heading>*/}
            {/*            <Text fontFamily="DMSans" fontSize={{base: "md", md: "xl"}}>{section.subtitle}</Text>*/}
            {/*        </MotionBox>*/}
            {/*        <MotionBox*/}
            {/*            flex="1"*/}
            {/*            display="flex"*/}
            {/*            align="center"*/}
            {/*            justify="space-between"*/}
            {/*            initial={{opacity: 0, y: 40}}*/}
            {/*            whileInView={{opacity: 1, y: 0}}*/}
            {/*            viewport={{once: true, amount: 0.5}}*/}
            {/*            whileHover={{scale: 1.01}}*/}
            {/*            transition={{type: "tween", stiffness: 400}}*/}
            {/*        >*/}
            {/*            <Image src={section.img} alt={section.title} rounded="2xl" shadow="lg" h="400px"/>*/}
            {/*        </MotionBox>*/}
            {/*    </MotionFlex>*/}
            {/*))}*/}

            <Text
                display="block"
                // bg={"gray.100"}
                pt={{base: 12, md: 24}}
                px={{base: 8, md: 24, lg: 48}}
                // px={{base: 4, md: 12, lg: 24}}
                fontSize={{base: "3xl", md: "4xl", lg: "5xl"}}
                fontWeight="bold"
                color="agxes.primary"
                textAlign={{base: "center", md: "center"}}
            >
                <MotionBox
                    // bg={"gray.100"}
                    rounded="3xl"
                    initial={{opacity: 0, y: 40}}
                    whileInView={{opacity: 1, y: 0}}
                    viewport={{once: true, amount: 0.1}}
                    transition={{duration: 0.8, ease: "easeOut"}}
                >
                    Turn messy agricultural data into financial insights and smart decisions.<br/>
                </MotionBox>
            </Text>
            {/*<Text*/}
            {/*    display="block"*/}
            {/*    mt={{base: 12, md: 24}}*/}
            {/*    mx={{base: 4, md: 12, lg: 24}}*/}
            {/*    px={{base: 4, md: 12, lg: 24}}*/}
            {/*    fontSize={{base: "4xl", md: "5xl", lg: "6xl"}}*/}
            {/*    fontWeight="bold"*/}
            {/*    color="agxes.primary"*/}
            {/*    textAlign={{base: "center", md: "left"}}*/}
            {/*>*/}
            {/*    <MotionBox*/}
            {/*        rounded="3xl"*/}
            {/*        initial={{opacity: 0, y: 40}}*/}
            {/*        whileInView={{opacity: 1, y: 0}}*/}
            {/*        viewport={{once: true, amount: 0.1}}*/}
            {/*        transition={{duration: 0.8, ease: "easeOut"}}*/}
            {/*    >*/}
            {/*        Smart AI Tools.<br/>*/}
            {/*    </MotionBox>*/}
            {/*    <MotionBox*/}
            {/*        rounded="3xl"*/}
            {/*        initial={{opacity: 0, y: 40}}*/}
            {/*        whileInView={{opacity: 1, y: 0}}*/}
            {/*        viewport={{once: true, amount: 0.1}}*/}
            {/*        transition={{duration: 0.8, ease: "easeOut"}}*/}
            {/*    >*/}
            {/*        Real Time Intelligence.<br/>*/}
            {/*    </MotionBox>*/}
            {/*    <MotionBox*/}
            {/*        rounded="3xl"*/}
            {/*        initial={{opacity: 0, y: 40}}*/}
            {/*        whileInView={{opacity: 1, y: 0}}*/}
            {/*        viewport={{once: true, amount: 0.1}}*/}
            {/*        transition={{duration: 0.8, ease: "easeOut"}}*/}
            {/*    >*/}
            {/*        Zero Friction.*/}
            {/*    </MotionBox>*/}
            {/*</Text>*/}

            <SimpleGrid
                columns={{base: 1, md: 2}}
                spacing={8}
                px={{base: 4, md: 16}}
                py={12}
            >
                {sections.map((section, idx) => (
                    <MotionBox
                        key={idx}
                        bg="white"
                        rounded="3xl"
                        shadow="md"
                        overflow="hidden"
                        p={8}
                        m={3}
                        initial={{opacity: 0, y: 40}}
                        whileInView={{opacity: 1, y: 0}}
                        viewport={{once: true, amount: 0.1}}
                        whileHover={{scale: 1.005}}
                        transition={{duration: 0.8, ease: "easeOut"}}
                    >
                        {/* Image on top */}
                        <Box mb={6}>
                            <Image
                                src={section.img}
                                alt={section.title}
                                rounded="2xl"
                                objectFit="cover"
                                w="full"
                                h={{base: "200px", md: "300px"}}
                                mb={4}
                            />
                        </Box>

                        {/* Text content */}
                        <Heading
                            color="agxes.primary"
                            fontFamily="DMSans"
                            fontSize={{base: "2xl", md: "3xl"}}
                            mb={2}
                            lineHeight="1.2"
                        >
                            {section.title}
                        </Heading>
                        <Text color="agxes.primary" fontFamily="DMSans" fontSize={{base: "md", md: "lg"}}>
                            {section.subtitle}
                        </Text>
                    </MotionBox>
                ))}
            </SimpleGrid>

            {/*{sections.map((section, idx) => (*/}
            {/*    <MotionFlex*/}
            {/*        key={idx}*/}
            {/*        direction={{base: "column", md: idx % 2 === 0 ? "row" : "row-reverse"}}*/}
            {/*        align="center"*/}
            {/*        justify="space-between"*/}
            {/*        px={{base: 4, md: 20}}*/}
            {/*        py={12}*/}
            {/*        gap={10}*/}
            {/*        initial={{opacity: 0, y: 40}}*/}
            {/*        whileInView={{opacity: 1, y: 0}}*/}
            {/*        viewport={{once: true, amount: 0.1}}*/}
            {/*        transition={{duration: 0.8, ease: "easeOut"}}*/}
            {/*    >*/}
            {/*        <MotionBox flex="1" initial={{opacity: 0, y: 40}} whileInView={{opacity: 1, y: 0}}*/}
            {/*                   transition={{duration: 0.8}}>*/}
            {/*            <Heading color="agxes.primary" fontFamily="DMSans" fontSize={{base: "3xl", md: "5xl"}} mb={4}>*/}
            {/*                {section.title}*/}
            {/*            </Heading>*/}
            {/*            <Text fontFamily="DMSans" fontSize={{base: "md", md: "xl"}}>{section.subtitle}</Text>*/}
            {/*        </MotionBox>*/}
            {/*        <MotionBox*/}
            {/*            flex="1"*/}
            {/*            initial={{opacity: 0, y: 40}}*/}
            {/*            whileInView={{opacity: 1, y: 0}}*/}
            {/*            viewport={{once: true, amount: 0.5}}*/}
            {/*            whileHover={{scale: 1.01}}*/}
            {/*            transition={{type: "tween", stiffness: 400}}*/}
            {/*        >*/}
            {/*            <Image src={section.img} alt={section.title} rounded="2xl" shadow="lg" h="400px"/>*/}
            {/*        </MotionBox>*/}
            {/*    </MotionFlex>*/}
            {/*))}*/}


            {/* NEWS SECTION */}


            {/* FULL-WIDTH IMAGE SCROLL SNAP */}
            {/*<Box*/}
            {/*    // w="1-- "*/}
            {/*    h="90vh"*/}
            {/*    display="flex"*/}
            {/*    overflowX="auto"*/}
            {/*    scrollSnapType="x mandatory"*/}
            {/*    sx={{"& > img": {scrollSnapAlign: "center"}}}*/}
            {/*>*/}
            {/*    {features.map((feature, idx) => (*/}
            {/*        <MotionBox*/}
            {/*            key={idx}*/}
            {/*            bg="agxes.primary"*/}
            {/*            p={8}*/}
            {/*            m={8}*/}
            {/*            w={"800px"}*/}
            {/*            rounded="3xl"*/}
            {/*            borderWidth="0.5px"*/}
            {/*            borderColor="gray.200"*/}
            {/*            shadow="xs"*/}
            {/*            whileHover={{scale: 1.01}}*/}
            {/*            transition={{duration: 0.2, ease: "easeOut"}}*/}
            {/*        >*/}

            {/*            /!*<Box borderWidth="0.5px" borderColor="gray.200" bg="white" rounded={"2xl"} p={8} m={8}>*!/*/}
            {/*            <Text color="white" fontFamily="DMSans" fontWeight="medium"*/}
            {/*                  fontSize={{base: "2xl", md: "4xl"}} mb={4}*/}
            {/*                  lineHeight="1.2">*/}
            {/*                {feature.title}*/}
            {/*            </Text>*/}
            {/*            <Text color={"white"} mb={4}>*/}
            {/*                {feature.subtitle}*/}
            {/*            </Text>*/}

            {/*            <Image*/}
            {/*                src={feature.img} alt={feature.title} w="full" h={"min"}*/}
            {/*                objectFit="cover"*/}
            {/*            />*/}
            {/*            <Box*/}
            {/*                position="absolute"*/}
            {/*                inset={0}*/}
            {/*                opacity={0.15}*/}
            {/*                pointerEvents="none"*/}
            {/*                rounded="3xl"*/}
            {/*                style={{*/}
            {/*                    backgroundImage:*/}
            {/*                    // "url('/grainy-noise.png')",*/}
            {/*                    // "url('/grain-Effect.png')",*/}
            {/*                    //     "url('/broken-noise.png')",*/}
            {/*                        "url('/grainy-noise-3.png')",*/}
            {/*                    backgroundSize: "cover",*/}
            {/*                    mixBlendMode: "overlay"*/}
            {/*                }}*/}
            {/*            />*/}

            {/*            /!*</Box>*!/*/}
            {/*        </MotionBox>*/}
            {/*    ))}*/}
            {/*</Box>*/}

            <Box
                // bg={"gray.100"}
            >
                <Box position="relative" mt={24} mb={12}
                    // bg={"gray.100"}
                >
                    {/* BACKGROUND */}
                    <Box
                        position="absolute"
                        top={0}
                        left={0}
                        right={0}
                        h={{base: "380px", md: "700px"}}
                        shadow={"xs"}
                        bg="agxes.secondary"
                        z-index={-1}
                        overflow="hidden"
                        rounded="4xl"
                        m={6}
                    >
                        <Box position="absolute" inset={0} overflow="hidden" z-index={-1} rounded="4xl">
                            {/* Moving radial gradients */}
                            <Box
                                position="absolute"
                                top="-10%"
                                left="-5%"
                                w="1000px"
                                h="900px"
                                bg="radial-gradient(circle, rgba(108,218,131,0.8) 0%, transparent 70%)"
                                filter="blur(40px)"
                                animation={`move2 12s ease-in-out infinite`}
                            />
                            <Box
                                position="absolute"
                                top="-10%"
                                left="25%"
                                w="1300px"
                                h="900px"
                                bg="radial-gradient(circle, rgba(108,218,131,0.6) 0%, transparent 70%)"
                                filter="blur(40px)"
                                animation={`move3 12s ease-in-out infinite`}
                            />

                            {/* Noise overlay */}
                            <Box
                                position="absolute"
                                inset={0}
                                opacity={0.1}
                                pointerEvents="none"
                                style={{
                                    backgroundImage: "url('/grainy-noise-3.png')",
                                    backgroundSize: "cover",
                                    mixBlendMode: "overlay",
                                }}
                            />
                        </Box>
                    </Box>


                    {/* VIDEO SECTION */}
                    <MotionBox
                        style={{y: parallaxY2}}
                        position="relative"
                        minH={{base: "auto", md: "100vh"}}   // no forced fullscreen on mobile
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        textAlign="center"
                        color="white"
                        pt={{base: "60px", md: "20px"}}      // smaller top padding on mobile
                        pb={{base: "60px", md: "0"}}         // add bottom padding so text isn't cramped
                    >
                        <Box
                            textAlign="center"
                            position="relative"
                            z-index={1}
                            w="full"
                            maxW="6xl"
                            mx="auto"
                        >
                            {/* Title */}
                            <Text
                                mx={{base: 4, md: 12, lg: 18}}
                                px={{base: 4, md: 12, lg: 24}}
                                fontSize={{base: "2xl", md: "4xl", lg: "5xl"}}  // slightly smaller font on mobile
                                fontWeight="bold"
                                color="white"
                                textAlign="center"
                            >
                                <MotionBox
                                    rounded="3xl"
                                    initial={{opacity: 0, y: 40}}
                                    whileInView={{opacity: 1, y: 0}}
                                    viewport={{once: true, amount: 0.1}}
                                    transition={{duration: 0.8, ease: "easeOut"}}
                                >
                                    Simply Deploy, Monitor, and Profit.
                                </MotionBox>
                                <MotionBox
                                    rounded="3xl"
                                    initial={{opacity: 0, y: 40}}
                                    whileInView={{opacity: 1, y: 0}}
                                    viewport={{once: true, amount: 0.1}}
                                    transition={{duration: 0.8, ease: "easeOut"}}
                                >
                                    Agxes Does the Rest.
                                </MotionBox>
                            </Text>

                            {/* Video */}
                            <MotionBox
                                initial={{opacity: 0, y: 40}}
                                whileInView={{opacity: 1, y: 0}}
                                viewport={{once: true, amount: 0.2}}
                                transition={{duration: 0.8, ease: "easeOut"}}
                                w="80%"
                                mx="auto"
                            >
                                <Box
                                    borderWidth="0.5px"
                                    borderColor="gray.300"
                                    mt={12}
                                    p="5px"
                                    rounded="2xl"
                                    bg="gray.200/30"
                                    w="full"
                                    maxW="1080px"
                                    mx="auto"
                                    shadow="lg"
                                >
                                    <Box position="relative" w="100%" pb="56.25%"> {/* 16:9 aspect ratio */}
                                        <Box
                                            as="video"
                                            src="https://agxes-website-assets.s3.us-east-1.amazonaws.com/short_demo.mp4"
                                            autoPlay
                                            muted
                                            loop
                                            playsInline
                                            controls={false}
                                            position="absolute"
                                            top="0"
                                            left="0"
                                            w="100%"
                                            h="100%"
                                            objectFit="cover"
                                            border="0"
                                            style={{borderRadius: "16px"}}
                                        />
                                    </Box>
                                </Box>
                            </MotionBox>

                        </Box>
                    </MotionBox>
                </Box>
            </Box>

            <Box m={{base: 8, md: 24}} color="agxes.primary">
                <SimpleGrid columns={{base: 1, md: 2}} gap={{base: 8, md: "40px"}}>
                    {/* Left side text + button */}
                    <GridItem>
                        <Text
                            fontSize={{base: "2xl", md: "4xl"}}
                            fontWeight="bold"
                            mb={4}
                            textAlign={{base: "center", md: "left"}}
                        >
                            Boost the profitability of your Business
                        </Text>

                        <Text
                            fontSize={{base: "md", md: "lg"}}
                            mb={{base: 6, md: 0}}
                            textAlign={{base: "center", md: "left"}}
                        >
                            Securely scale your Farm Bank, Credit Union, Community Bank, or CDFI, while remaining
                            compliant and
                            without increasing
                            headcount
                        </Text>
                        {/*<Text*/}
                        {/*    fontSize={{base: "sm", md: "md"}}*/}
                        {/*    color="gray.600"*/}
                        {/*    mb={{base: 6, md: 4}}*/}
                        {/*    textAlign={{base: "center", md: "left"}}*/}
                        {/*>*/}
                        {/*    Built with SOC 2–aligned security and GLBA, ECOA, and FCRA compliance at its core.*/}
                        {/*</Text>*/}

                        <Flex justify={{base: "center", md: "flex-start"}}>
                            <Button
                                as="a"
                                href={contactUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                mt={6}
                                fontSize={{base: "md", md: "lg"}}
                                size="lg"
                                bg="agxes.primary"
                                rounded="lg"
                                color="white"
                                boxShadow="inset 0 0 8px rgba(255, 255, 255, 0.5)"
                                _hover={{
                                    bg: "agxes.primaryLight",
                                    boxShadow: "inset 0 0 10px rgba(255, 255, 255, 0.35)",
                                }}
                                transition="all 0.3s ease"
                            >
                                Talk with us
                            </Button>
                        </Flex>
                    </GridItem>

                    {/* Right side stats */}
                    <GridItem ml={{base: 0, md: 8}}>
                        <SimpleGrid columns={{base: 2, md: 2}} gap={{base: 6, md: "40px"}}>
                            <GridItem textAlign="center">
                                <Text fontSize={{base: "3xl", md: "5xl"}} fontWeight="bold">
                                    50%
                                </Text>
                                <Text fontSize={{base: "sm", md: "md"}}>
                                    Increase in Loan Approvals
                                </Text>
                            </GridItem>

                            <GridItem textAlign="center">
                                <Text fontSize={{base: "3xl", md: "5xl"}} fontWeight="bold">
                                    98%
                                </Text>
                                <Text fontSize={{base: "sm", md: "md"}}>
                                    Reduction in Analysis Time
                                </Text>
                            </GridItem>

                            <GridItem textAlign="center">
                                <Text fontSize={{base: "3xl", md: "5xl"}} fontWeight="bold">
                                    100%
                                </Text>
                                <Text fontSize={{base: "sm", md: "md"}}>
                                    Data Privacy and Compliance Controls
                                </Text>
                            </GridItem>

                            <GridItem textAlign="center">
                                <Text fontSize={{base: "3xl", md: "5xl"}} fontWeight="bold">
                                    200x
                                </Text>
                                <Text fontSize={{base: "sm", md: "md"}}>
                                    Loan Throughput Increase
                                </Text>
                            </GridItem>
                        </SimpleGrid>
                    </GridItem>
                </SimpleGrid>
            </Box>


            {/*<Box bg={"gray.200"}>*/
            }
            {/*    <Box position="relative" mt={24} mb={24} bg={"gray.100"}>*/
            }
            {/*        /!* BACKGROUND *!/*/
            }
            {/*        <Box*/
            }
            {/*            position="absolute"*/
            }
            {/*            top={0}*/
            }
            {/*            bottom={0}*/
            }
            {/*            left={0}*/
            }
            {/*            right={0}*/
            }
            {/*            shadow="xs"*/
            }
            {/*            bg="agxes.secondary"*/
            }
            {/*            z-index={-1}*/
            }
            {/*            overflow="hidden"*/
            }
            {/*            rounded="4xl"*/
            }
            {/*            m={6}*/
            }
            {/*        >*/
            }
            {/*            <Box position="absolute" inset={0} overflow="hidden" z-index={-1} rounded="3xl">*/
            }
            {/*                /!* Moving radial gradients *!/*/
            }
            {/*                <Box*/
            }
            {/*                    position="absolute"*/
            }
            {/*                    top="-10%"*/
            }
            {/*                    left="-5%"*/
            }
            {/*                    w="1000px"*/
            }
            {/*                    h="900px"*/
            }
            {/*                    bg="radial-gradient(circle, rgba(108,218,131,0.8) 0%, transparent 70%)"*/
            }
            {/*                    filter="blur(40px)"*/
            }
            {/*                    animation={`move2 12s ease-in-out infinite`}*/
            }
            {/*                />*/
            }
            {/*                <Box*/
            }
            {/*                    position="absolute"*/
            }
            {/*                    top="-10%"*/
            }
            {/*                    left="25%"*/
            }
            {/*                    w="1300px"*/
            }
            {/*                    h="900px"*/
            }
            {/*                    bg="radial-gradient(circle, rgba(108,218,131,0.6) 0%, transparent 70%)"*/
            }
            {/*                    filter="blur(40px)"*/
            }
            {/*                    animation={`move3 12s ease-in-out infinite`}*/
            }
            {/*                />*/
            }

            {/*                /!* Noise overlay *!/*/
            }
            {/*                <Box*/
            }
            {/*                    position="absolute"*/
            }
            {/*                    inset={0}*/
            }
            {/*                    opacity={0.1}*/
            }
            {/*                    pointerEvents="none"*/
            }
            {/*                    style={{*/
            }
            {/*                        backgroundImage: "url('/grainy-noise-3.png')",*/
            }
            {/*                        backgroundSize: "cover",*/
            }
            {/*                        mixBlendMode: "overlay",*/
            }
            {/*                    }}*/
            }
            {/*                />*/
            }
            {/*            </Box>*/
            }
            {/*        </Box>*/
            }

            {/*        /!* VIDEO SECTION *!/*/
            }
            {/*        <Box*/
            }
            {/*            textAlign="center"*/
            }
            {/*            pt={24}*/
            }
            {/*            mb={24}*/
            }
            {/*            position="relative"*/
            }
            {/*            z-index={1}*/
            }
            {/*            w="full"*/
            }
            {/*            maxW="6xl"*/
            }
            {/*            mx="auto"*/
            }
            {/*        >*/
            }
            {/*            <Text*/
            }
            {/*                display="block"*/
            }
            {/*                // mt={24}*/
            }
            {/*                mx={24}*/
            }
            {/*                px={24}*/
            }
            {/*                fontSize="5xl"*/
            }
            {/*                fontWeight="bold"*/
            }
            {/*                color="white"*/
            }
            {/*                textAlign="left"*/
            }
            {/*            >*/
            }
            {/*                <MotionBox*/
            }
            {/*                    rounded="3xl"*/
            }
            {/*                    initial={{opacity: 0, y: 40}}*/
            }
            {/*                    whileInView={{opacity: 1, y: 0}}*/
            }
            {/*                    viewport={{once: true, amount: 0.1}}*/
            }
            {/*                    transition={{duration: 0.8, ease: "easeOut"}}*/
            }
            {/*                >*/
            }
            {/*                    Agricultural Lending,*/
            }
            {/*                </MotionBox>*/
            }
            {/*                <MotionBox*/
            }
            {/*                    rounded="3xl"*/
            }
            {/*                    initial={{opacity: 0, y: 40}}*/
            }
            {/*                    whileInView={{opacity: 1, y: 0}}*/
            }
            {/*                    viewport={{once: true, amount: 0.1}}*/
            }
            {/*                    transition={{duration: 0.8, ease: "easeOut"}}*/
            }
            {/*                >*/
            }
            {/*                    Automated.*/
            }
            {/*                </MotionBox>*/
            }
            {/*            </Text>*/
            }
            {/*            /!*<Heading fontFamily="DMSans" fontWeight="bold" fontSize="5xl" pb={12} color="white"*!/*/
            }
            {/*            /!*         lineSpacing={1}>*!/*/
            }
            {/*            /!*    Agricultural Lending, <br/>*!/*/
            }
            {/*            /!*    Automated.*!/*/
            }
            {/*            /!*</Heading>*!/*/
            }


            {/*            <Box*/
            }
            {/*                borderWidth="0.5px"*/
            }
            {/*                borderColor="gray.300"*/
            }
            {/*                mt={12}*/
            }
            {/*                p="5px"*/
            }
            {/*                rounded="2xl"*/
            }
            {/*                bg="gray.200/30"*/
            }
            {/*                w="min"*/
            }
            {/*                shadow="lg"*/
            }
            {/*            >*/
            }
            {/*                <Box*/
            }
            {/*                    as="iframe"*/
            }
            {/*                    src="https://www.youtube.com/embed/ZnjEscJCrWA?autoplay=1&mute=1&controls=1&loop=1&playlist=ZnjEscJCrWA"*/
            }
            {/*                    allow="autoplay; fullscreen"*/
            }
            {/*                    rounded="xl"*/
            }
            {/*                    w="800px"*/
            }
            {/*                    h="450px"*/
            }
            {/*                    // h={{base: "200px", md: "400px"}}*/
            }
            {/*                    border="0"*/
            }
            {/*                    style={{borderRadius: "16px"}}*/
            }
            {/*                />*/
            }
            {/*            </Box>*/
            }
            {/*        </Box>*/
            }
            {/*    </Box>*/
            }
            {/*</Box>*/
            }


            {/*<MotionBox*/
            }
            {/*    rounded="3xl"*/
            }
            {/*    initial={{opacity: 0, y: 40}}*/
            }
            {/*    whileInView={{opacity: 1, y: 0}}*/
            }
            {/*    viewport={{once: true, amount: 0.1}}*/
            }
            {/*    transition={{duration: 0.8, ease: "easeOut"}}*/
            }
            {/*>*/
            }
            {/*    <Text*/
            }
            {/*        textAlign={{base: "center", md: "left"}}*/
            }
            {/*        mx={{base: 4, md: 12, lg: 24}}*/
            }
            {/*        px={{base: 4, md: 12, lg: 24}}*/
            }
            {/*        mb={{base: 8, md: 16}}*/
            }
            {/*        fontSize={{base: "4xl", md: "5xl", lg: "6xl"}}*/
            }
            {/*        fontWeight="bold"*/
            }
            {/*        color="agxes.primary"*/
            }
            {/*    >*/
            }
            {/*        Boost Loan Approvals and Drive Business Growth.*/
            }
            {/*    </Text>*/
            }
            {/*</MotionBox>*/
            }


            {/*<Box*/
            }
            {/*    h="90vh"*/
            }
            {/*    w={"full"}*/
            }
            {/*    display="flex"*/
            }
            {/*    overflowX="auto"*/
            }
            {/*    scrollSnapType="x mandatory"*/
            }
            {/*    sx={{"& > img": {scrollSnapAlign: "center"}}}*/
            }
            {/*>*/
            }
            {/*    {features.map((feature, idx) => (*/
            }
            {/*        <MotionBox*/
            }
            {/*            key={idx}*/
            }
            {/*            bg="agxes.primary"*/
            }
            {/*            p={8}*/
            }
            {/*            m={8}*/
            }
            {/*            w="full"*/
            }
            {/*            rounded="3xl"*/
            }
            {/*            borderWidth="0.5px"*/
            }
            {/*            borderColor="gray.200"*/
            }
            {/*            shadow="xs"*/
            }
            {/*            position="relative"*/
            }
            {/*            whileHover={{scale: 1.01}}*/
            }
            {/*            transition={{duration: 0.2, ease: "easeOut"}}*/
            }
            {/*        >*/
            }
            {/*            /!* Noise overlay only on background *!/*/
            }
            {/*            <Box*/
            }
            {/*                position="absolute"*/
            }
            {/*                inset={0}*/
            }
            {/*                opacity={0.15}*/
            }
            {/*                pointerEvents="none"*/
            }
            {/*                rounded="3xl"*/
            }
            {/*                zIndex={0}*/
            }
            {/*                style={{*/
            }
            {/*                    backgroundImage: "url('/grainy-noise-3.png')",*/
            }
            {/*                    backgroundSize: "cover",*/
            }
            {/*                    mixBlendMode: "overlay"*/
            }
            {/*                }}*/
            }
            {/*            />*/
            }

            {/*            /!* Content above noise *!/*/
            }
            {/*            <Box position="relative" zIndex={1}>*/
            }
            {/*                <Text*/
            }
            {/*                    color="white"*/
            }
            {/*                    fontFamily="DMSans"*/
            }
            {/*                    fontWeight="medium"*/
            }
            {/*                    fontSize={{base: "2xl", md: "4xl"}}*/
            }
            {/*                    mb={4}*/
            }
            {/*                    lineHeight="1.2"*/
            }
            {/*                >*/
            }
            {/*                    {feature.title}*/
            }
            {/*                </Text>*/
            }
            {/*                <Text color="white" mb={4}>*/
            }
            {/*                    {feature.subtitle}*/
            }
            {/*                </Text>*/
            }
            {/*                <Image*/
            }
            {/*                    src={feature.img}*/
            }
            {/*                    alt={feature.title}*/
            }
            {/*                    w="full"*/
            }
            {/*                    objectFit="cover"*/
            }
            {/*                />*/
            }
            {/*            </Box>*/
            }
            {/*        </MotionBox>*/
            }
            {/*    ))}*/
            }
            {/*</Box>*/
            }

            {/*<MotionBox*/
            }
            {/*    // bg={"agxes.primary"}*/
            }
            {/*    rounded="3xl"*/
            }
            {/*    initial={{opacity: 0, y: 40}}*/
            }
            {/*    whileInView={{opacity: 1, y: 0}}*/
            }
            {/*    viewport={{once: true, amount: 0.1}}*/
            }
            {/*    transition={{duration: 0.8, ease: "easeOut"}}*/
            }
            {/*>*/
            }
            {/*    <Box*/
            }
            {/*        h={{base: "70vh", md: "90vh"}}*/
            }
            {/*        display="flex"*/
            }
            {/*        overflowX="auto"*/
            }
            {/*        scrollSnapType="x mandatory"*/
            }
            {/*        scrollBehavior="smooth" // smooth scrolling*/
            }
            {/*        mb={24}*/
            }
            {/*        px={{base: 4, md: 12, lg: 24}} // padding for first & last feature*/
            }
            {/*        sx={{*/
            }
            {/*            "& > div": {scrollSnapAlign: "center"},*/
            }
            {/*            // Hide scrollbar (WebKit: Chrome, Safari, Opera)*/
            }
            {/*            "::-webkit-scrollbar": {display: "none"},*/
            }
            {/*            // Hide scrollbar (Firefox)*/
            }
            {/*            scrollbarWidth: "none",*/
            }
            {/*            // Hide scrollbar (IE/Edge)*/
            }
            {/*            msOverflowStyle: "none",*/
            }
            {/*            // Optional: enable smooth touch scroll on Safari iOS*/
            }
            {/*            WebkitOverflowScrolling: "touch",*/
            }
            {/*        }}*/
            }
            {/*    >*/
            }
            {/*        {features.map((feature, idx) => (*/
            }
            {/*            <MotionBox*/
            }
            {/*                key={idx}*/
            }
            {/*                bg="agxes.primary"*/
            }
            {/*                p={8}*/
            }
            {/*                m={4} // spacing between cards*/
            }
            {/*                w={{base: "80%", md: "300px", lg: "400px"}}*/
            }
            {/*                flexShrink={0}*/
            }
            {/*                rounded="4xl"*/
            }
            {/*                borderWidth="0.5px"*/
            }
            {/*                borderColor="gray.200"*/
            }
            {/*                shadow="xs"*/
            }
            {/*                position="relative"*/
            }
            {/*                whileHover={{scale: 1.01}}*/
            }
            {/*                transition={{duration: 0.2, ease: "easeOut"}}*/
            }
            {/*            >*/
            }
            {/*                /!* Noise overlay only on background *!/*/
            }
            {/*                <Box*/
            }
            {/*                    position="absolute"*/
            }
            {/*                    inset={0}*/
            }
            {/*                    opacity={0.15}*/
            }
            {/*                    pointerEvents="none"*/
            }
            {/*                    rounded="4xl"*/
            }
            {/*                    z-index={0}*/
            }
            {/*                    style={{*/
            }
            {/*                        backgroundImage: "url('/grainy-noise-3.png')",*/
            }
            {/*                        backgroundSize: "cover",*/
            }
            {/*                        mixBlendMode: "overlay",*/
            }
            {/*                    }}*/
            }
            {/*                />*/
            }

            {/*                /!* Content above noise *!/*/
            }
            {/*                <Box position="relative" z-index={1}>*/
            }
            {/*                    <Text*/
            }
            {/*                        color="white"*/
            }
            {/*                        fontFamily="DMSans"*/
            }
            {/*                        fontWeight="medium"*/
            }
            {/*                        fontSize={{base: "2xl", md: "4xl"}}*/
            }
            {/*                        mb={4}*/
            }
            {/*                        lineHeight="1.2"*/
            }
            {/*                    >*/
            }
            {/*                        {feature.title}*/
            }
            {/*                    </Text>*/
            }
            {/*                    <Text color="white" mb={4}>*/
            }
            {/*                        {feature.subtitle}*/
            }
            {/*                    </Text>*/
            }
            {/*                    <Image*/
            }
            {/*                        src={feature.img}*/
            }
            {/*                        alt={feature.title}*/
            }
            {/*                        // w="full"*/
            }
            {/*                        h={{base: "300px", md: "400px", lg: "480px"}}*/
            }
            {/*                        objectFit="cover"*/
            }
            {/*                        rounded="2xl"*/
            }
            {/*                    />*/
            }
            {/*                </Box>*/
            }
            {/*            </MotionBox>*/
            }
            {/*        ))}*/
            }
            {/*    </Box>*/
            }
            {/*</MotionBox>*/
            }

            {/*<Box bg={"agxes.secondary"}>*/
            }
            {/*    <Box bg={"gray.100"} roundedBottom={"full"} h={"20px"}>*/
            }
            {/*    </Box>*/
            }
            {/*</Box>*/
            }

            {/*<Box id="news" textAlign="center" py={12} bg={"agxes.secondary"}>*/
            }
            {/*    <Heading fontFamily="DMSans" fontWeight="bold" fontSize="4xl" mb={10} color="white">Latest*/
            }
            {/*        News</Heading>*/
            }
            {/*    <SimpleGrid columns={{base: 1, md: 3}} spacing={10} px={{base: 4, md: 20}} mx={4} gap={"20px"}>*/
            }
            {/*        {news.map((item, idx) => (*/
            }
            {/*            <MotionBox key={idx} p={6} bg="white" rounded="xl" shadow="md" whileHover={{scale: 1.01}}*/
            }
            {/*                       transition={{duration: 0.2, ease: "easeOut"}}>*/
            }
            {/*                <Heading fontFamily="DMSans" fontSize="xl" mb={2}*/
            }
            {/*                         color="agxes.primary">{item.title}</Heading>*/
            }
            {/*                <Text fontFamily="DMSans" fontSize="sm" color="gray.500">{item.date}</Text>*/
            }
            {/*                <Text fontFamily="DMSans" mt={3}>{item.description}</Text>*/
            }
            {/*            </MotionBox>*/
            }
            {/*        ))}*/
            }
            {/*    </SimpleGrid>*/
            }
            {/*</Box>*/
            }


            <Box
                // bg={"gray.200"}
            >
                <Box position="relative" mt={24} mb={24}
                    // bg={"gray.100"}
                >
                    {/* BACKGROUND */}
                    <Box
                        position="absolute"
                        top={0}
                        bottom={0}
                        left={0}
                        right={0}
                        shadow={"xs"}
                        bg="agxes.accent"
                        z-index={-1}
                        overflow="hidden"
                        rounded="4xl"
                        m={6}
                        // h={"min"}
                    >
                        <Box position="absolute" inset={0} overflow="hidden" z-index={-1} rounded="4xl">
                            {/* Moving radial gradients */}
                            <Box
                                position="absolute"
                                top="-10%"
                                left="-5%"
                                w="1000px"
                                h="900px"
                                bg="radial-gradient(circle, rgba(83,171,145,0.8) 0%, transparent 70%)"
                                filter="blur(40px)"
                                animation={`move2 12s ease-in-out infinite`}
                            />
                            <Box
                                position="absolute"
                                top="-10%"
                                left="25%"
                                w="1300px"
                                h="900px"
                                bg="radial-gradient(circle, rgba(83,171,145,0.6) 0%, transparent 70%)"
                                filter="blur(40px)"
                                animation={`move3 12s ease-in-out infinite`}
                            />

                            {/* Noise overlay */}
                            <Box
                                position="absolute"
                                inset={0}
                                opacity={0.1}
                                pointerEvents="none"
                                style={{
                                    backgroundImage: "url('/grainy-noise-3.png')",
                                    backgroundSize: "cover",
                                    mixBlendMode: "overlay",
                                }}
                            />
                        </Box>
                    </Box>

                    {/* NEWS SECTION */}
                    {/*<Box*/}
                    {/*    id="news"*/}
                    {/*    textAlign="center"*/}
                    {/*    pt={24}*/}
                    {/*    pb={6}*/}
                    {/*    position="relative"*/}
                    {/*    z-index={1}*/}
                    {/*    _before={{*/}
                    {/*        content: '""',*/}
                    {/*        position: "absolute",*/}
                    {/*        top: 0,*/}
                    {/*        left: 0,*/}
                    {/*        right: 0,*/}
                    {/*        height: "150px",*/}
                    {/*        bgGradient: "linear(to-b, rgba(0,0,0,0.1), transparent)",*/}
                    {/*        pointerEvents: "none",*/}
                    {/*    }}*/}
                    {/*>*/}
                    {/*    /!* Title *!/*/}
                    {/*    <MotionBox*/}
                    {/*        initial={{opacity: 0, y: 40}}*/}
                    {/*        whileInView={{opacity: 1, y: 0}}*/}
                    {/*        viewport={{once: true, amount: 0.2}}*/}
                    {/*        transition={{duration: 0.8, ease: "easeOut"}}*/}
                    {/*        w="full"*/}
                    {/*        maxW="7xl"*/}
                    {/*        mx="auto"*/}
                    {/*    >*/}
                    {/*        <Heading fontFamily="DMSans" fontWeight="bold" fontSize="5xl" pb={16} color="white">*/}
                    {/*            Latest News*/}
                    {/*        </Heading>*/}
                    {/*    </MotionBox>*/}
                    {/*    <SimpleGrid*/}
                    {/*        columns={{base: 1, md: 3}}*/}
                    {/*        spacing={{base: 6, md: 10}}*/}
                    {/*        px={{base: 4, md: 20}}*/}
                    {/*        mx={4}*/}
                    {/*    >*/}
                    {/*        {news.map((item, idx) => (*/}
                    {/*            <MotionBox*/}
                    {/*                key={idx}*/}
                    {/*                p={{base: 4, md: 6}}*/}
                    {/*                mx={4}*/}
                    {/*                mb={8}*/}
                    {/*                bg="white"*/}
                    {/*                rounded="xl"*/}
                    {/*                shadow="md"*/}
                    {/*                whileHover={{scale: 1.01}}*/}
                    {/*                whileInView={{opacity: 1, y: 0}}*/}
                    {/*                initial={{opacity: 0, y: 40}}*/}
                    {/*                viewport={{once: true, amount: 0.2}}*/}
                    {/*                transition={{duration: 1, ease: "easeOut", delay: idx * 0.15}}*/}
                    {/*            >*/}
                    {/*                /!* Image *!/*/}
                    {/*                <Flex justify="center">*/}
                    {/*                    <Box*/}
                    {/*                        w={{base: "100%", sm: "50%", md: "200px"}}*/}
                    {/*                        h="150px"           // fixed container height*/}
                    {/*                        display="flex"*/}
                    {/*                        alignItems="center"*/}
                    {/*                        justifyContent="center"*/}
                    {/*                        borderRadius="md"*/}
                    {/*                        overflow="hidden"*/}
                    {/*                    >*/}
                    {/*                        <Image*/}
                    {/*                            src={item.image}*/}
                    {/*                            maxW="100%"*/}
                    {/*                            maxH="100%"*/}
                    {/*                            objectFit="contain"  // 👈 keeps full image visible*/}
                    {/*                        />*/}
                    {/*                    </Box>*/}
                    {/*                </Flex>*/}


                    {/*                /!* Title *!/*/}
                    {/*                <Heading*/}
                    {/*                    fontFamily="DMSans"*/}
                    {/*                    fontSize={{base: "lg", md: "xl"}}*/}
                    {/*                    mb={2}*/}
                    {/*                    color="agxes.primary"*/}
                    {/*                    textAlign="center"*/}
                    {/*                >*/}
                    {/*                    {item.title}*/}
                    {/*                </Heading>*/}

                    {/*                /!* Date *!/*/}
                    {/*                <Text*/}
                    {/*                    fontFamily="DMSans"*/}
                    {/*                    fontSize="sm"*/}
                    {/*                    color="gray.500"*/}
                    {/*                    textAlign="center"*/}
                    {/*                >*/}
                    {/*                    {item.date}*/}
                    {/*                </Text>*/}

                    {/*                /!* Description *!/*/}
                    {/*                <Text*/}
                    {/*                    fontFamily="DMSans"*/}
                    {/*                    mt={3}*/}
                    {/*                    fontSize={{base: "sm", md: "md"}}*/}
                    {/*                    textAlign={{base: "justify", md: "justify"}}*/}
                    {/*                >*/}
                    {/*                    {item.description}*/}
                    {/*                </Text>*/}
                    {/*            </MotionBox>*/}
                    {/*        ))}*/}
                    {/*    </SimpleGrid>*/}
                    {/*</Box>*/}
                    <Box
                        ref={sectionRef}
                        id="news"
                        textAlign="center"
                        pt={24}
                        pb={12}
                        position="relative"
                        zIndex={1}
                        _before={{
                            content: '""',
                            position: "absolute",
                            top: 0,
                            left: 0,
                            right: 0,
                            height: "150px",
                            bgGradient: "linear(to-b, rgba(0,0,0,0.1), transparent)",
                            pointerEvents: "none",
                        }}
                    >
                        <MotionBox
                            initial={{opacity: 0, y: 40}}
                            whileInView={{opacity: 1, y: 0}}
                            viewport={{once: true, amount: 0.2}}
                            transition={{duration: 0.8, ease: "easeOut"}}
                            w="full"
                            maxW="7xl"
                            mx="auto"
                        >
                            <Heading fontFamily="DMSans" fontWeight="bold" fontSize="5xl" pb={16} color="white">
                                Latest News
                            </Heading>
                        </MotionBox>

                        <SimpleGrid
                            columns={{base: 1, md: 3}}
                            gap={{base: 6, md: 10}}
                            px={{base: 4, md: 20}}
                            mx={4}
                        >
                            {visibleNews.map((item, idx) => (
                                <MotionBox
                                    key={idx}
                                    p={{base: 4, md: 6}}
                                    mb={8}
                                    bg="white"
                                    rounded="xl"
                                    shadow="md"
                                    whileHover={{scale: 1.01}}
                                    // We want them to animate in when they appear
                                    initial={{opacity: 0, y: 20}}
                                    animate={{opacity: 1, y: 0}}
                                    transition={{duration: 0.5, delay: (idx % 3) * 0.1}}
                                >
                                    <Flex justify="center" mb={4}>
                                        <Box
                                            w={{base: "100%", sm: "50%", md: "200px"}}
                                            h="150px"
                                            display="flex"
                                            alignItems="center"
                                            justifyContent="center"
                                            borderRadius="md"
                                            overflow="hidden"
                                        >
                                            <Image
                                                src={item.image}
                                                maxW="100%"
                                                maxH="100%"
                                                objectFit="contain"
                                            />
                                        </Box>
                                    </Flex>

                                    <Heading
                                        fontFamily="DMSans"
                                        fontSize={{base: "lg", md: "xl"}}
                                        mb={2}
                                        color="agxes.primary"
                                        textAlign="center"
                                    >
                                        {item.title}
                                    </Heading>

                                    <Text fontFamily="DMSans" fontSize="sm" color="gray.500" textAlign="center">
                                        {item.date}
                                    </Text>

                                    <Text
                                        fontFamily="DMSans"
                                        mt={3}
                                        fontSize={{base: "sm", md: "md"}}
                                        textAlign="justify"
                                    >
                                        {item.description}
                                    </Text>
                                </MotionBox>
                            ))}
                        </SimpleGrid>

                        {/* Toggle Button */}
                        {hasMoreThanThree && (
                            <Flex justify="center" mt={0}>
                                <Button
                                    variant="outline"
                                    color="white"
                                    borderColor="whiteAlpha.400"
                                    _hover={{bg: "whiteAlpha.200"}}
                                    onClick={toggleNews}
                                    fontFamily="DMSans"
                                    size="lg"
                                    gap={2}
                                >
                                    {showAll ? (
                                        <>
                                            Show Less <FiChevronUp/>
                                        </>
                                    ) : (
                                        <>
                                            Show Older News <FiChevronRight/>
                                        </>
                                    )}
                                </Button>
                            </Flex>
                        )}
                    </Box>
                </Box>
            </Box>


            <Box bg={"agxes.primary"}>
                <Box
                    bg={"white"}
                    roundedBottom={"full"} h={"35px"}>
                </Box>
            </Box>

            {/* PARTNERSHIPS SECTION */
            }
            {/*<Box bg={"agxes.primary"}>*/
            }
            {/*    <Box id="partners" textAlign="center" py={{base: 10, md: 20}} bg="gray.200" roundedBottom={"4xl"}>*/
            }
            {/*        <Heading fontFamily="DMSans" fontSize={{base: "3xl", md: "4xl"}} mb={10}*/
            }
            {/*                 color="agxes.primary">Supported By</Heading>*/
            }
            {/*        <Flex justify="center" gap={10} wrap="wrap">*/
            }
            {/*            {partners.map((logo, idx) => (*/
            }
            {/*                <Image key={idx} src={logo} alt={`Partner ${idx}`} w="150px" objectFit="contain"/>*/
            }
            {/*            ))}*/
            }
            {/*        </Flex>*/
            }
            {/*    </Box>*/
            }
            {/*</Box>*/
            }


            {/*<Box bg={"agxes.primary"}>*/
            }
            {/*    <Box bg={"gray.100"} roundedBottom={"full"} h={"20px"}>*/
            }
            {/*    </Box>*/
            }
            {/*</Box>*/
            }


            {/* FOOTER */
            }
            <Box as="footer" bg="agxes.primary" color="gray.300" py={10} px={{base: 6, md: 20}}>
                <Flex direction={{base: "column", md: "row"}} justify="space-between" align="flex-start" gap={10}>
                    <Flex direction="column" gap={4} maxW="600px">
                        <Image src="/logo.png" alt="Agxes Logo" mb={0} w={36}/>
                        <Text fontFamily="DMSans" fontWeight="medium" color="white"
                              fontSize={{base: "3xl", md: "5xl"}} lineHeight="1.2">
                            Score,
                            Monitor,
                            and Scale your business
                            with certainty.</Text>
                        <Link href="https://www.linkedin.com/company/agxes" target="_blank" rel="noopener noreferrer">
                            <FaLinkedin color="white" size={24}/>
                        </Link>

                    </Flex>

                    <Flex gap={{base: 10, md: 20}} wrap="wrap">
                        {/*<Flex fontFamily="DMSans" direction="column" gap={2}>*/}
                        {/*    <Heading fontSize="xs" mb={1} fontWeight="normal" color="white">COMPANY</Heading>*/}
                        {/*    <Link*/}
                        {/*        href="/"*/}
                        {/*        color="gray.200"*/}
                        {/*        textDecoration="none"*/}
                        {/*        _hover={{color: "gray.100", textDecoration: "underline"}}*/}
                        {/*        transition="color 0.3s ease, text-decoration 0.6s ease"*/}
                        {/*    >*/}
                        {/*        Home*/}
                        {/*    </Link>*/}
                        {/*    <Link*/}
                        {/*        href="/blog"*/}
                        {/*        color="gray.200"*/}
                        {/*        textDecoration="none"*/}
                        {/*        _hover={{color: "gray.100", textDecoration: "underline"}}*/}
                        {/*        transition="color 0.3s ease, text-decoration 0.6s ease"*/}
                        {/*    >*/}
                        {/*        Blog*/}
                        {/*    </Link>*/}
                        {/*    <Link*/}
                        {/*        href="/careers"*/}
                        {/*        color="gray.200"*/}
                        {/*        textDecoration="none"*/}
                        {/*        _hover={{color: "gray.100", textDecoration: "underline"}}*/}
                        {/*        transition="color 0.3s ease, text-decoration 0.6s ease"*/}
                        {/*    >*/}
                        {/*        Careers*/}
                        {/*    </Link>*/}
                        {/*</Flex>*/}

                        {/*<Flex direction="column" gap={2}>*/}
                        {/*    <Heading fontSize="xs" mb={1} fontWeight="normal" color="white">LEGAL</Heading>*/}
                        {/*    <Link*/}
                        {/*        href="/privacy"*/}
                        {/*        color="gray.200"*/}
                        {/*        textDecoration="none"*/}
                        {/*        _hover={{color: "gray.100", textDecoration: "underline"}}*/}
                        {/*        transition="color 0.3s ease, text-decoration 0.6s ease"*/}
                        {/*    >*/}
                        {/*        Privacy Policy*/}
                        {/*    </Link>*/}
                        {/*    <Link*/}
                        {/*        href="/terms"*/}
                        {/*        color="gray.200"*/}
                        {/*        textDecoration="none"*/}
                        {/*        _hover={{color: "gray.100", textDecoration: "underline"}}*/}
                        {/*        transition="color 0.3s ease, text-decoration 0.6s ease"*/}
                        {/*    >*/}
                        {/*        Terms of Use*/}
                        {/*    </Link>*/}
                        {/*</Flex>*/}

                        <Flex direction="column" gap={2}>
                            <Heading fontSize="xs" mb={1} fontWeight="normal" color="white">CONTACT</Heading>
                            <Link
                                href="mailto:victoria.tostado@agxes.com"
                                color="gray.200"
                                // textDecoration="none"
                                // _hover={{color: "gray.100", textDecoration: "underline"}}
                                // transition="color 1s ease, text-decoration 6s ease"
                            >
                                <Text textDecoration="none"
                                      _hover={{color: "gray.100", textDecoration: "underline"}}
                                      transition="color 1s ease, text-decoration 6s ease">
                                    victoria.tostado@agxes.com
                                </Text>

                            </Link>
                        </Flex>
                    </Flex>

                </Flex>

                <Text fontFamily="DMSans" textAlign="center" fontSize="sm" mt={6}>
                    &copy; {new Date().getFullYear()} Agxes, Inc. All rights reserved.
                </Text>
            </Box>
        </Box>
    )
        ;
}
